import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

// Models
import { CmsMenuResponse } from '@core/models/cms/cms-menu.model';

/**
 * API du menu CMS public — retourne la liste des applications accessibles.
 */
@Injectable({
	providedIn: 'root',
})
export class CmsMenuApi {
	constructor(private http: HttpClient) {}

	getMenus(nomdt: number): Observable<CmsMenuResponse> {
		return this.http.post<CmsMenuResponse>('public/json/cmsmenu/query', { nomdt });
	}
}
